import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { ArchivedGroupShipments } from '@uturn/portal/modules/shipments';
import {
	GroupedShipmentsSearchSchema,
	SHIPMENTS_SEARCH_DEFAULT_STATUSES_ARCHIVED,
	ShipmentsSearchStatusesSchema,
} from '@uturn/portal/router/schema/shipments-search';

const ArchivedGroupedShipmentsSearchSchema =
	GroupedShipmentsSearchSchema.extend({
		'filter.statuses': fallback(
			ShipmentsSearchStatusesSchema.array(),
			SHIPMENTS_SEARCH_DEFAULT_STATUSES_ARCHIVED,
		).default(SHIPMENTS_SEARCH_DEFAULT_STATUSES_ARCHIVED),
	});

export const Route = createFileRoute(
	'/_protected/shipments/groups/$groupId/archived',
)({
	component: ArchivedGroupShipments,
	validateSearch: zodValidator(ArchivedGroupedShipmentsSearchSchema),
});
